import React, { useState, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextareaAutosize from 'react-textarea-autosize';


const TextArea = props => {
  const { field, form, placeholder, readOnly, disabled, className, icon, isRequired, annotation, validationError, labelClassName, maxLength } = props;

  const error = validationError || form.errors[field.name];
  const hasValue = field.value != null && field.value !== '';
  const [isFocused, setFocus] = useState(false);

  return (
    <label className={classNames(`field field-textarea ${className}`, {
      'field--focused': isFocused,
      'field--filled': hasValue,
      'field--error': (error != null) && (form.submitCount > 0 || form.touched[field.name]),
    })}>
      <div className="field__data">
        {
          // (isFocused || hasValue) &&
          <span className={`field-label field-input__label ${labelClassName}`}>
            {placeholder}
            {
              isRequired && <span className="field-label__required">*</span>
            }
          </span>
        }
        <TextareaAutosize
          {...field}
          disabled={disabled}
          maxLength={maxLength}
          readOnly={readOnly}
          placeholder={placeholder}
          onFocus={() => setFocus(true)}
          onBlur={event => {
            field.onBlur(event);
            setFocus(false);
          }}
          className="field__textarea"
          value={field.value || ""} />
        {
          annotation &&
          <span className='field-annotation'>{annotation}</span>
        }
        {
          (form.submitCount > 0 || form.touched[field.name]) &&
          <span className='field-error'>{error}</span>
        }
      </div>
    </label>
  )
}

TextArea.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
}

TextArea.defaultProps = {
  className: '',
  labelClassName: '',
  form: {
    errors: {}
  },
  field: {
    name: '',
    onBlur: () => { },
  }
}

export default TextArea;